/** @module csi/widget/_svg/EditSeparator */
define([
	"dijit/ToolbarSeparator",
	"./_Plugin",
	"./PluginFactory"
], function(Separator,_Plugin,PluginFactory) {

	return PluginFactory.declare([Separator,_Plugin], {
		pluginName: "editSeparator",

		/**
		 * Only show this separator if the edit button is shown
		 * @return {boolean}
		 */
		canShowPlugin: function() {
			return this.editor.view.canEditCanvas() && !this.editor.editMode;
		}
	});
});